export const stockBalanceHistoryStatusColors = {
  1001: 'yellow',
  1002: 'green',
};

export const stockBalanceHistoryStatusLabels = {
  1001: 'Đang xử lý',
  1002: 'Thành công',
};

export const stockBalanceHistoriesTypeColors = {
  1001: 'green',
  1002: 'yellow',
};

export const stockBalanceHistoriesStatusOptions = [
  { value: '1001', label: 'Đang xử lý' },
  { value: '1002', label: 'Thành công' },
];

export const stockBalanceHistoriesTypeOptions = [
  { value: '1001', label: 'Nạp' },
  { value: '1002', label: 'Rút' },
];
